import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';

import NavbarComponent from './components/Navbar';
import Footer from './components/Footer'
import Home from './pages/Home'
import About from './pages/About'
import OurServices from './pages/OurServices'
import Products from './pages/Products'
import Contact from './pages/Contact';

import 'bootstrap/dist/css/bootstrap.min.css';
import './custom-theme.css';




export default function App() {
  return (
    <Router>
      <ScrollToTop />
      {/* ScrollToTop component to reset scroll position on route change */}
      <div className="d-flex flex-column min-vh-100">
        <NavbarComponent />
        <main className="flex-grow-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/our-services" element={<OurServices />} />
            <Route path="/products" element={<Products />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <a
          href="https://wa.me/917888159898"
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-float"
        >
          <i className="bi bi-whatsapp whatsapp-float-icon"></i>
        </a>

        <Footer />
      </div>
    </Router>
  );
}
